import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { DialogTitleProps } from './DialogTitle.props';
import { StyledCloseButton, StyledTitle } from './DialogTitle.styles';

const DialogTitle = ({ children, onClose, dialogProps, ...other }: DialogTitleProps) => {
  const { disableTitleClose } = dialogProps;

  return (
    <MuiDialogTitle {...(other as any)} component="div">
      <StyledTitle variant="h6">{children}</StyledTitle>
      {onClose && !disableTitleClose && (
        <StyledCloseButton aria-label="close" onClick={onClose}>
          <CloseIcon />
        </StyledCloseButton>
      )}
    </MuiDialogTitle>
  );
};

export default DialogTitle;
